import { v4 as randomUUID } from 'uuid';

import {
	Calendar,
	Certificate,
	Chart,
	Notes,
	Objects,
	Puzzle,
	Settings,
	Sliders,
	UserCrown,
	UserTie,
} from '../shared/Assets/menuIcons';

export interface MenuProperties {
	Icon?: any;
	id: string;
	permission: string | null;
	title: string;
	url: string;
}

export const FORM_URL = 'https://www.superform.spot-nik.com/form/67e6ba94ef3b418a7284c0d0';

export const PERMISSIONS = {
	SUPERADMIN: 'all',
	CLIENT: {
		READ: 'client.read',
		CREATE: 'client.create',
		EDIT: 'client.edit',
		DELETE: 'client.delete',
	},
	USER: {
		READ: 'user.read',
		CREATE: 'user.create',
		EDIT: 'user.edit',
		DELETE: 'user.delete',
		IMPERSONATE: 'user.impersonate',
	},
	SOAPNOTE: {
		READ: 'soapnote.read',
		UNLOCK: 'admin.soapnote.unlock',
		PDF: 'soapnote.pdf',
		CREATE: 'soapnote.create',
		EDIT: 'soapnote.edit',
		POST_SUBMIT_EDIT: 'admin.soapnote.postsubmit.edit',
		REINFORCEMENTS_READ: 'reinforcement.read',
		REINFORCEMENTS_EDIT: 'reinforcement.edit',
		ASSIGN_BCBA: 'client.assignment.bcba',
		ASSIGN_RBT: 'client.assignment.rbt',
	},
	REPORT: {
		UTILIZATION: 'admin.report.utilization.download',
		GRAPH: 'report.graph.download',
		SOAPNOTE: 'admin.report.soapnote.download',
		NONCREDENTIALED: 'admin.report.noncredentialed.detailed.download',
		NONCREDENTIALED_TOTAL: 'admin.report.noncredentialed.total.download',
		MBH: 'admin.report.mbh.detailed.download',
		BACKDATED: 'admin.report.backdated.download',
		NONBILLABLE: 'admin.report.magnonbillable.total.download',
	},
	INSURANCE_AUTHORIZATION: {
		READ: 'client.auth.read',
		CREATE: 'client.auth.create',
		EDIT: 'client.auth.edit',
		DELETE: 'client.auth.delete',
		ALLOCATE: 'client.auth.allocate',
	},
	INSURANCE: {
		READ: 'insurance.read',
		CREATE: 'insurance.create',
		EDIT: 'insurance.edit',
		DELETE: 'insurance.delete',
	},
};

const GENERAL: MenuProperties[] = [
	{
		id: randomUUID(),
		title: 'Dashboard',
		url: '/dashboard',
		permission: null,
		Icon: Objects,
	},
	{
		id: randomUUID(),
		title: 'Calendar',
		url: '/calendar',
		permission: PERMISSIONS.SOAPNOTE.CREATE,
		Icon: Calendar,
	},
	{
		id: randomUUID(),
		title: 'Clients',
		url: '/clients',
		permission: PERMISSIONS.CLIENT.READ,
		Icon: UserTie,
	},
	{
		id: randomUUID(),
		title: 'SOAP Notes',
		url: '/soap-notes',
		permission: PERMISSIONS.SOAPNOTE.READ,
		Icon: Notes,
	},
];

const ADMIN_URLS: MenuProperties[] = [
	// { id: randomUUID(), title: "All Users", url: "/user", permission: PERMISSIONS.USER.READ, Icon: Users },
	{
		id: randomUUID(),
		title: 'Admin',
		url: '/admin',
		permission: PERMISSIONS.USER.READ,
		Icon: Settings,
	},
	{
		id: randomUUID(),
		title: 'BCBA',
		url: '/bcba',
		permission: PERMISSIONS.USER.READ,
		Icon: Certificate,
	},
	{
		id: randomUUID(),
		title: 'Behavior Technician',
		url: '/bt',
		permission: PERMISSIONS.USER.READ,
		Icon: Puzzle,
	},
	{
		id: randomUUID(),
		title: 'Clinical Supervisor',
		url: '/cs',
		permission: PERMISSIONS.USER.READ,
		Icon: UserCrown,
	},
	{
		id: randomUUID(),
		title: 'Insurances',
		url: '/insurances',
		permission: PERMISSIONS.INSURANCE.READ,
		Icon: Certificate,
	},
	{
		id: randomUUID(),
		title: 'Schedules',
		url: '/schedules',
		permission: PERMISSIONS.CLIENT.READ,
		Icon: Calendar,
	},
	{
		id: randomUUID(),
		title: 'ADP Rate Mappings',
		url: '/adp-rate-mappings',
		permission: PERMISSIONS.SUPERADMIN,
		Icon: Sliders,
	},
	{
		id: randomUUID(),
		title: 'Monday Sync',
		url: '/monday-sync',
		permission: PERMISSIONS.SUPERADMIN,
		Icon: Puzzle,
	},
	{
		id: randomUUID(),
		title: 'Permissions',
		url: '/permissions',
		permission: PERMISSIONS.SUPERADMIN,
		Icon: Sliders,
	},
	{
		id: randomUUID(),
		title: 'Reports',
		url: '/reports',
		permission: null,
		Icon: Chart,
	},
];

const ADMIN: MenuProperties[] = [...GENERAL, ...ADMIN_URLS];

const BCBA: MenuProperties[] = [
	...GENERAL,
	{
		id: randomUUID(),
		title: 'Schedules',
		url: '/schedules',
		permission: PERMISSIONS.CLIENT.READ,
		Icon: Calendar,
	},
	{
		id: randomUUID(),
		title: 'Reports',
		url: '/reports',
		permission: null,
		Icon: Chart,
	},
];

const BT: MenuProperties[] = GENERAL;
const CS: MenuProperties[] = BCBA;

export const MENU = {
	ADMIN,
	ADMIN_URLS,
	GENERAL,
	BCBA,
	BT,
	CS,
};
